import { Component, OnInit } from '@angular/core';

import { NotificationService, Notification } from '../../_services/notification.service'

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  notifications: Array<Notification> = []
  constructor(private _notificationService: NotificationService) { }

  ngOnInit() {
    this._notificationService.showNotificaticationEvent.subscribe((notification: Notification) => {
      this.notifications.push(notification)
      if (!notification.isLoading) {
        setTimeout(() => {
          const index = this.notifications.indexOf(notification)
          if (index !== -1) {
            this.notifications.splice(index, 1);
          }
        }, 5000)
      }
    })

    this._notificationService.changeStatusEvent.subscribe((data: Object) => {
      let notification = this.getNotification(data["id"])
      if (notification) {
        notification.isLoading = false
        notification.message = data["message"]
        notification.type = data["type"]

        setTimeout(() => {
          const index = this.notifications.indexOf(notification)
          if (index !== -1) {
            this.notifications.splice(index, 1);
          }
        }, 5000)
      }
    })

    this._notificationService.stopLoadingEvent.subscribe((data: Object) => {
      let notification = this.getNotification(data["id"])
      if (notification) {
        notification.isLoading = false;
        notification.message = data["message"]
        notification.type = data["type"]

        setTimeout(() => {
          const index = this.notifications.indexOf(notification)
          if (index !== -1) {
            this.notifications.splice(index, 1);
          }
        }, 5000)
      }
    })

    this._notificationService.closeNotificationEvent.subscribe((id) => {
      let notification = this.getNotification(id)
      if (notification) {
        const index = this.notifications.indexOf(notification)
        if (index !== -1) {
          this.notifications.splice(index, 1);
        }
      }
    })
  }

  private getNotification(id: String): Notification {
    let notification = this.notifications.filter((notification) => notification.id == id)[0]
    return notification
  }

}
